<template>
  <section :class="$style.PWAsideBodyItem">
    <header :class="$style.PWAsideBodyItemHeader">
      <slot name="header">
        {{ title }}
      </slot>
    </header>
    <div v-if="$slots.default">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Заголовок'
    }
  }
}
</script>

<style module lang="scss">
@use '@/assets/scss/mixins';

.PWAsideBodyItem {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.PWAsideBodyItemHeader {
  display: inline-flex;

  @include mixins.body1Bold;
}
</style>
